import { useState } from "react";
import { motion, useScroll, AnimatePresence } from "framer-motion";
import { Moon, Sun, Menu, X, Landmark } from "lucide-react";

const LINKS = [
  { label: "Cursos", href: "#cursos", id: "nav-link-cursos" },
  { label: "Metodología", href: "#metodologia", id: "nav-link-metodologia" },
  { label: "Precios", href: "#precios", id: "nav-link-precios" },
  { label: "Blog", href: "#blog", id: "nav-link-blog" },
  { label: "Instructora", href: "#instructora", id: "nav-link-instructora" },
  { label: "Contacto", href: "#contacto", id: "nav-link-contacto" },
];

export const Navbar = ({ theme, onToggleTheme, onEnroll }) => {
  const [open, setOpen] = useState(false);
  const { scrollYProgress } = useScroll();

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header data-testid="main-navbar" className="fixed top-0 inset-x-0 z-50">
      <div className="backdrop-blur-xl bg-background/80 border-b border-border/60">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <a href="#" data-testid="nav-logo" onClick={(e) => go(e, "#hero")} className="flex items-center gap-2.5 group">
            <span className="w-9 h-9 rounded-lg bg-gradient-to-br from-emerald-500 to-emerald-700 text-white flex items-center justify-center shadow-lg shadow-emerald-500/25 group-hover:scale-105 transition-transform">
              <Landmark className="w-5 h-5" />
            </span>
            <span className="font-display font-bold tracking-tight text-lg leading-none">
              CapacitaCon
              <span className="block text-[10px] font-mono font-normal tracking-[0.22em] uppercase text-muted-foreground">Capacitación Contable</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-7">
            {LINKS.map((l) => (
              <a
                key={l.id}
                href={l.href}
                data-testid={l.id}
                onClick={(e) => go(e, l.href)}
                className="text-sm text-muted-foreground hover:text-foreground transition-colors relative after:absolute after:-bottom-1 after:left-0 after:h-px after:w-0 after:bg-primary after:transition-all hover:after:w-full"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2.5">
            <button
              data-testid="theme-toggle-btn"
              onClick={onToggleTheme}
              aria-label="Cambiar tema"
              className="w-9 h-9 rounded-full border border-border flex items-center justify-center text-muted-foreground hover:text-foreground hover:border-primary/50 transition-colors"
            >
              {theme === "dark" ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
            </button>
            <button
              data-testid="nav-enroll-btn"
              onClick={() => onEnroll()}
              className="hidden sm:inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground text-sm font-semibold px-5 py-2.5 hover:brightness-110 active:scale-95 transition-all shadow-lg shadow-emerald-500/20"
            >
              Inscribirme ahora
            </button>
            <button
              data-testid="mobile-menu-btn"
              onClick={() => setOpen(!open)}
              aria-label="Menú"
              className="lg:hidden w-9 h-9 rounded-full border border-border flex items-center justify-center"
            >
              {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
            </button>
          </div>
        </div>
        <motion.div className="h-[2px] bg-gradient-to-r from-emerald-500 via-amber-400 to-emerald-500 origin-left" style={{ scaleX: scrollYProgress }} />
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            className="lg:hidden backdrop-blur-xl bg-background/95 border-b border-border px-6 py-5 flex flex-col gap-4"
          >
            {LINKS.map((l) => (
              <a key={l.id} href={l.href} data-testid={`${l.id}-mobile`} onClick={(e) => go(e, l.href)} className="text-base font-medium">
                {l.label}
              </a>
            ))}
            <button
              data-testid="nav-enroll-btn-mobile"
              onClick={() => { setOpen(false); onEnroll(); }}
              className="rounded-full bg-primary text-primary-foreground font-semibold px-5 py-3 text-sm"
            >
              Inscribirme ahora
            </button>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
